import React from 'react'
import ForecastSkeleton from '../../../ForecastSkeleton'
import MapWeather from '../../../../../MapWeather'

const ForecastPrognosisSkeleton = ({ textBlocks, ...props }) => (
  <ForecastSkeleton elementBelowTitle={<MapWeather data={[]} />} textBlocks={textBlocks} {...props} />
)

export default ForecastPrognosisSkeleton
